import styled from "styled-components";
import { Modal as BaseModal } from "antd";

export const Modal = styled(BaseModal)`
  .ant-modal-body {
    display: flex;
    place-content: center;
    > div {
      min-width: 350px;
    }
  }
`;
